/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useState, useCallback, useRef, useContext } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import { useDispatch, useSelector } from 'react-redux';
import { dataService } from '../../../services/data.services';
import Table from './Components/Table';
import CardHeader from '../../../components/CardHeader';
import { ManageInvoiceList } from './InvoiceListSlice';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import EmptyAddScreen from '../../../components/EmptyAddScreen';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import Toast from '../../../components/Toast';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import Debounce from '../../../CommonMethods/Debounce';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import Filter from './TopBarComponents/Filter'
import Search from './TopBarComponents/Search';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import GlobalContext from '../../../components/Context/GloablContext';
import { formatAdjustedDate } from '../../../CommonMethods/formatDate';
import moment from 'moment';
import InvoiceScheduledModal from '../../InventoryMaster/InventoryList/Components/IssueInventory/InvoiceScheduledModal';

const InvoiceList  = () => {
    const [searchParams, setSearchParams] = useSearchParams({page_number:1});
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const navigate = useNavigate('')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [finacialYear, setFinacialYear] = useState('')
    const [academicYears, setAcademicYears] = useState('')
    const [loading, setLoading] =useState(true)
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [FilterData, setFilterData] = useState({
        date_range: [],
        invoice_type: ["All", "Fee", "Inventory"],
        status: ["All", "Paid", "Unpaid", "Unpaid or Partially Paid", "Partially Paid"]
    });
    const [filterCount, setFilterCount] = useState(0)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const dispatch = useDispatch();
    const [invoiceScheduledModalOpen, setInvoiceScheduledModalOpen] = useState(false);
    const StudentsDirectoryList = useSelector(state => state.StudentsDirectorySlice);
    const { List } = StudentsDirectoryList
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [FYLoading, setFYLoading] = useState(true);
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const placeholderOptions = [
        'Student Name / ID',
        'Invoice #'
    ];
    const {  isInactiveBranch, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [threeDotOpen, setThreeDotOpen] = useState(false);
    const threeDotRef = useRef();

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
        
    //Fliter Functions----
    /**
         * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
         * filters out null or undefined values, updates the state with the filtered values, and counts the
         * number of filtered values.
         */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
            invoice_type: searchParams.get('invoice_type'),
            status: searchParams.get('status'),
        };
            // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
            // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };
        /**
         * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
         * updates the `filterCount` state variable accordingly.
         */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    /**
         * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
         * the filter open state.
         */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedFilter('date_range')
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }
    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
        element. In this case, it is used to detect clicks outside of the filter component. When a click is
        detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
        is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
         * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
         * object's id, dateString, and selectedFilter.
         */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
         * The function `handleApplyFilter` is used to apply filters to a search query and update the search
         * parameters accordingly.
         */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            } else {
                params.dropname = 'Academic Year';
            }
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            const searchParam = searchParams.get('search');
            searchParam !== null ? setSearchParams({'search': searchParam}) : setSearchParams({}); 
            setSelectedDateRange('Financial Year')
            setSelectedName(currentFinacialYear)
            setFilterCheckBox([])
            setSelectedFilter('date_range')
        }
        getCount(type)
    }
    //----
    
    //Search Functions ----
    /**
         * The function `handleSearchParams` updates the search parameters by adding or modifying a key-value
         * pair, and then updates the state with the new search parameters.
         */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    /* The `optimizedFn` is a memoized version of the `Debounce` function that is used to debounce the
        `handleSearchParams` function. Debouncing is a technique used to limit the number of times a
        function is called by delaying its execution until after a certain amount of time has passed since
        the last time it was invoked. */
    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }
    
    /**
         * The function `getAcademicYears` retrieves ongoing and upcoming academic years from an API based on
         * the branch ID and sets the retrieved data to the state variable `AcademicYears`.
         */
    const getAcademicYears = async() => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=completed,ongoing,upcoming`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp = response?.data?.data?.data
        setAcademicYears(temp)
    }
    
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({page_number:1})
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getInvoiceList = useCallback(async () => {
        setLoading(true);
        try {
            let branch_id = await GetBranchId();
            const modifiedSearchParams = new URLSearchParams(searchParams);
            // Modify invoice_type to lowercase
            const invoiceType = modifiedSearchParams.get('invoice_type');
            if (invoiceType) {
                modifiedSearchParams.set('invoice_type', invoiceType.toLowerCase());
            }
            modifiedSearchParams.delete('transactionId')
            modifiedSearchParams.delete("transaction_id");
            modifiedSearchParams.delete("bulk_page_number");
            modifiedSearchParams.delete("student_page_number");;
            modifiedSearchParams.delete('totalStudents')
            modifiedSearchParams.delete('isScheduleModal')
            modifiedSearchParams.delete("sFromInvoiceList");
            const invoiceStatus = modifiedSearchParams.get('status');
            
            if (invoiceStatus) {
                modifiedSearchParams.set('status', invoiceStatus.toLowerCase());
            }
            modifiedSearchParams.delete('dropname')
            modifiedSearchParams.delete('main')
            let endpoint = `invoice?filter=true&branch_id=${branch_id.toString()}&${modifiedSearchParams.toString()}${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`;
            dispatch(ManageInvoiceList(endpoint)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response?.payload?.data?.data?.data?.length === 0 && searchParams.get('search')===null && searchParams.get('filter')===null&& response?.payload?.data?.data?.total_count === 0 ) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found");  
                    }
                    if(Math.ceil(response?.payload?.data?.data?.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data?.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found");
                        }
                        
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                    setLoading(false)
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            updateFilterCheckBox()
            // setsearchFieldDebounce(searchParams.get('search') !== null ? searchParams.get('search') : '')
        } catch (error) {
            handleLoadData()
            console.log(error)
            setEmptyScreenMessage("No data found");
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [searchParams, FYLoading]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /* `useEffect(() => { getInstitutionUsers(); }, [getInstitutionUsers]);` is a hook that is used to run
    the `getInstitutionUsers` function whenever the `getInstitutionUsers` function changes. In this case,
    the `getInstitutionUsers` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getInstitutionUsers` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(()=>{
        
        if (startDate != null && !FYLoading ){
            getInvoiceList()
        }
    },[startDate, FYLoading, getInvoiceList])

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);


    /* The below code is using the `useEffect` hook in a React component. It is calling three different API
    functions: `getClassesAPI()`, `getSectionsAPI()`, and `getFinancialYears()`. These functions are
    likely used to fetch data from an API. The `useEffect` hook is used to perform these API calls when
    the component mounts. The empty array `[]` as the second argument to `useEffect` ensures that the
    API calls are only made once, when the component initially mounts. */
    useEffect(()=>{
        getFinancialYears()
        getAcademicYears()
    },[])

    useEffect(() => {
        function handleClickOutside(event) {
            if (threeDotRef.current && !threeDotRef.current.contains(event.target)) {
                setThreeDotOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleThreeDottedButton = (e) => {
        const params = new URLSearchParams(searchParams)
        // params.set("start_date", startDate.substring(0, 10));
        // params.set("end_date", endDate.substring(0, 10));
        // setSearchParams({ start_date: startDate, end_date: endDate });
        navigate(`/student-master/invoice-list/bulk-invoice-history/?${params.toString()}`);
    };

    useEffect(() => {
        if (searchParams.get("isScheduleModal")) {
            setInvoiceScheduledModalOpen(true)
        }    
    }, [])
    
    const removeParams = () => {
        const params = new URLSearchParams(searchParams);
        params.delete("transactionId");
        params.delete("isScheduleModal");
        params.delete("totalStudents");
        setSearchParams(params);
    };

    const OnClose = () => {
        removeParams()
        setInvoiceScheduledModalOpen(false)
    }

    return (
        <CardHeader noPadding>
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex items-center">
                    <h5 class="pageHeader adderror">
                        Invoices
                    </h5>
                </div> 
                <div className='flex items-center'>
                    { <Search
                        SearchValue={searchFieldDebounce}
                        handleOnClickSearch={setsearchFieldDebounce}
                        optimizedFn={optimizedFn}
                        customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    />}
                    { <div class="relative">
                        <button onClick={() => {
                            handleOpenFilter()
                        }} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            filterCount={filterCount}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={setSelectedDateRange}
                            selectedName={selectedName}
                            setSelectedName={setSelectedName}
                            searchParams={searchParams}
                            ref={outSideClick}
                            currentFinacialYear={currentFinacialYear}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}  
                            radioButton={true}   
                            finacialYear={finacialYear}  
                            academicYears={academicYears}
                            setSearchParams={setSearchParams} 
                            setStartDate={setStartDate} 
                            setEndDate={setEndDate}   
                            calculateEndDate={calculateEndDate} 
                        />}
                    </div>}
                    {!isInactiveBranch && <button onClick={()=>navigate('/student-master/invoice-list/issue-inventory')}  id="addAdmin_user" className="prmy-btn">
                        Issue Invoice
                    </button>}
                    <div className="relative ml-0" ref={threeDotRef}>
                        <button
                            type="button"
                            className="more_actn_btn"
                            onClick={() => setThreeDotOpen((o) => !o)}
                            data-te-dropdown-toggle-ref
                            aria-expanded="false"
                            data-te-ripple-init
                            data-te-ripple-color="light"
                        >
                            <img loading="lazy" decoding="async" src="/images/three_dotted_download.svg" alt="icon" className="prevent-click" />
                        </button>
                        {threeDotOpen && (
                            <ul className="three_dot_btn_drp_dwn wid4 shadow-s1">
                                <li>
                                    <button
                                        className="w-full text-left px-3 cursor-pointer  font-normal text-[#031624] hover:text-[#106EB4]"
                                        onClick={() => {
                                            setThreeDotOpen(false);
                                            handleThreeDottedButton();
                                        }}
                                    >
                                        Bulk Invoice Issue History
                                    </button>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <div class="mainDataCntnrListDiv scrollBlue_thick">
                {loading ? <ItemShimmer classkey={"mt-[32px]"} />
                    : (
                        <>
                            <div className="-mx-1">
                                <Table
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickSort={handleSearchParams}
                                    sortValue={searchParams.get('sort') || ''}
                                    email={email}
                                    setLoading={setLoading}
                                    totalCount={List?.total_count}
                                    searchParams={searchParams}
                                    startDate={startDate} 
                                    endDate={endDate}
                                />
                                {(List?.total_count > 10) && <Pagination
                                    TotalCount={List?.total_count}
                                    totalPageNumber={Math.ceil(List?.total_count / 10)}
                                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                />}
                            </div>
                        </> 
                    )
                }
            </div>
            {searchParams.get('isScheduleModal') && (
                <InvoiceScheduledModal
                    open={invoiceScheduledModalOpen}
                    onClose={OnClose}
                    removeParams= {removeParams}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    studentCount={searchParams.get('totalStudents')}
                    transactionId = {searchParams.get('transactionId')}
                />
            )}
            {toastErrorMessage!=='' &&
                <Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
        </CardHeader>
    );
}

export default InvoiceList;
